import * as Yup from "yup";

export const BusinessHrsValidationSchema = Yup.object().shape({
    message: Yup.string().min(10).max(100).required().label("Message"),
});